import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as actions from '../../action';
import * as c from '../../constant';

function PropertyAssessmentTab({
  getPropertyAssessmentHistoryList,
  propertyAssessmentList,
  historyId,
  isLoading,
}) {
  useEffect(() => {
    if (_.isEmpty(historyId)) return;
    getPropertyAssessmentHistoryList(historyId);
  }, [historyId]);

  return (
    <div className="card-content-listing">
      <div className="card p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              <div className="table-div">
                <table className="css-table table table-borderless table-sm table-striped table-hover">
                  <thead className="table-header">
                    <tr>
                      <td className="font-weight-bold" width="150">
                        Actual Use
                      </td>
                      <td className="font-weight-bold">Market Value</td>
                      <td className="font-weight-bold">Assessment Level</td>
                      <td className="font-weight-bold">Assessed Value</td>
                      <td className="font-weight-bold">Taxability</td>
                      <td className="font-weight-bold" width="150">
                        Tax Exempt Code
                      </td>
                      <td className="font-weight-bold">Exemption Reason</td>
                    </tr>
                  </thead>
                  <tbody>
                    {propertyAssessmentList &&
                      propertyAssessmentList.length <= 0 && (
                        <tr className="text-center">
                          <td className="history-color" colSpan="9">
                            No data
                          </td>
                        </tr>
                      )}
                    {propertyAssessmentList &&
                      propertyAssessmentList.map((item) => (
                        <tr key={item.id}>
                          <td className="history-color">
                            {_.get(item, 'attributes.actual_use')}
                          </td>
                          <td className="history-color">
                            {_.get(item, 'attributes.market_value')}
                          </td>
                          <td className="history-color">
                            {_.get(item, 'attributes.assessment_level')}
                          </td>
                          <td className="history-color">
                            {_.get(item, 'attributes.assessed_value')}
                          </td>
                          <td className="history-color">
                            <input
                              name="taxability"
                              type="checkbox"
                              checked={_.get(item, 'attributes.taxability')}
                              onChange={() => {}}
                              readOnly
                            />
                          </td>
                          <td className="history-color">
                            {_.get(item, 'attributes.tax_exempt_code')}
                          </td>
                          <td className="history-color">
                            {_.get(item, 'attributes.tax_exempt_reason')}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

PropertyAssessmentTab.defaultProps = {
  historyId: '',
};

PropertyAssessmentTab.propTypes = {
  getPropertyAssessmentHistoryList: PropTypes.instanceOf(Function).isRequired,
  propertyAssessmentList: PropTypes.instanceOf(Array).isRequired,
  historyId: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  propertyAssessmentList:
    _.get(api, `${c.GET_MACHINERY_PROPERTY_ASSESSMENT_HISTORY_LIST}.list`) ||
    [],
  isLoading:
    _.get(api, 'loading', []).indexOf(
      c.GET_MACHINERY_PROPERTY_ASSESSMENT_HISTORY_LIST
    ) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PropertyAssessmentTab);
